import { NavLink, To } from 'react-router-dom';
import classNames from 'classnames';

import { Typography } from '../../../components';

import styles from './NavItem.module.scss';

export interface INavItemProps {
    url: To;
    title: string;
}

export const NavItem = ({ title, url }: INavItemProps) => {
    return (
        <li className={styles.navItem}>
            <NavLink
                to={url}
                className={({ isActive, isPending }) =>
                    classNames(styles.navLink, {
                        [styles.active]: isActive || isPending,
                    })
                }
            >
                <Typography variant="base14" color="white" fontWeight="inherit">
                    {title}
                </Typography>
            </NavLink>
        </li>
    );
};
